"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LobTitleProps_1 = require("./LobTitleProps");
var styles = require("./LobTitle.scss");
var icons = require("../../../../styles/ccc-icons-cart.scss");
var cartViewPanelCss = require("../../../panels/CartViewPanel/CartViewPanel.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var components_1 = require("@idp/duc/components");
var LobTitle = /** @class */ (function (_super) {
    __extends(LobTitle, _super);
    function LobTitle(props) {
        var _this = _super.call(this, props) || this;
        _this.testId = '';
        _this.editText = 'Edit';
        _this.removeText = 'Remove';
        _this.lineOfBusinessName = '';
        _this.getIconFromOps = _this.getIconFromOps.bind(_this);
        _this.setVar = _this.setVar.bind(_this);
        _this.openRemoveItemModal = _this.openRemoveItemModal.bind(_this);
        _this.onEditItem = _this.onEditItem.bind(_this);
        _this.showLinks = _this.showLinks.bind(_this);
        return _this;
    }
    Object.defineProperty(LobTitle.prototype, "ariaLabelContent", {
        get: function () {
            return " " + (this.props.data && this.props.data.lineOfBusinessName || '') + ",\n         " + (this.props.options && this.props.options.accessibility || '');
        },
        enumerable: false,
        configurable: true
    });
    LobTitle.prototype.getIconFromOps = function () {
        if (this.props && this.props.data && this.props.data.show) {
            var data = this.props.data;
            if (data.planType === LobTitleProps_1.PlanType.WIRELESS || data.planType === LobTitleProps_1.PlanType.WIRELESS_CRP
                || data.planType === LobTitleProps_1.PlanType.WIRELESS_PREPAID) {
                return [icons.cccIconCartMobilesmartphoneL, cartViewPanelCss.wirelessCartIcon];
            }
            else if (data.planType === LobTitleProps_1.PlanType.BROADBAND) {
                return [icons.cccIconCartInternetL, cartViewPanelCss.broadbandCartIcon];
            }
            else if (data.planType === LobTitleProps_1.PlanType.ACCESSORIES) {
                return [icons.cccIconCartAccessoriesL, cartViewPanelCss.accessoriesCartIcon];
            }
            return [];
        }
        else {
            return [];
        }
    };
    LobTitle.prototype.setVar = function () {
        this.lineOfBusinessName = this.props.data && this.props.data.lineOfBusinessName || '';
        this.testId = this.props.testId || '';
    };
    LobTitle.prototype.openRemoveItemModal = function () {
        if (this.props && this.props.events && this.props.events.onRemove) {
            this.props.events.onRemove();
        }
    };
    LobTitle.prototype.onEditItem = function () {
        if (this.props && this.props.events && this.props.events.onEdit) {
            this.props.events.onEdit();
        }
    };
    LobTitle.prototype.render = function () {
        if (this.props && this.props.data && this.props.data.show) {
            var iconClasses = __spreadArrays([icons.cccIconCart, icons.cccIconCartLg], this.getIconFromOps());
            this.setVar();
            return (React.createElement("div", { className: styles.titleContainer },
                React.createElement("div", { className: styles.displayFlex },
                    React.createElement("div", { className: styles.planIcon },
                        React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-label": this.ariaLabelContent })),
                    React.createElement("div", { className: styles.titleText },
                        React.createElement(ui_components_1.Label, { testId: utils_1.default('Lob', 'Title', this.lineOfBusinessName), data: { text: this.lineOfBusinessName }, options: { className: styles.lobTitle } }))),
                this.showLinks()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    LobTitle.prototype.showLinks = function () {
        if (this.props && this.props.options && this.props.options.linksToShow) {
            var links = this.props.options.linksToShow.split('|');
            return (React.createElement("div", { className: [styles.displayFlex, styles.linkText].join(' ') },
                links.indexOf(LobTitleProps_1.LinksToShow.EDIT) !== -1 &&
                    React.createElement("div", null,
                        React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default(this.props.testId, 'Link', 'EditPlan'), onClick: this.onEditItem, "aria-label": this.editText + this.lineOfBusinessName, className: CartConfiguration_scss_1.cartLinkMedium }, this.editText)),
                links.indexOf(LobTitleProps_1.LinksToShow.REMOVE) !== -1 && React.createElement("span", { className: CartConfiguration_scss_1.cartPipeSeparator }),
                links.indexOf(LobTitleProps_1.LinksToShow.REMOVE) !== -1 &&
                    React.createElement("div", null,
                        React.createElement(components_1.Link, { testId: utils_1.default(this.props.testId, 'Link', 'Remove'), kind: "textPlain", onClick: this.openRemoveItemModal, "aria-label": this.removeText + this.lineOfBusinessName, className: CartConfiguration_scss_1.cartLinkMedium }, this.removeText))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    return LobTitle;
}(React.Component));
exports.default = LobTitle;
//# sourceMappingURL=LobTitle.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/LobTitle/LobTitle.js
// module id = 2369
// module chunks = 8